mutation UpdateCampaignFeedsMutation($campaignId: ID!, $feedUrl: String!, $primaryKey: String!, $group: String!) {
    updateCampaignFeeds(campaignId: $campaignId, feedUrl: $feedUrl, primaryKey: $primaryKey, group: $group)
}
